<template>
  <div class="pl-form-input-group" :class="[{'invalid-group': isShown }, groupClass]">
    <div v-if="title" class="pl-form-label" :class="[titleClass]">
      {{title}}>
    </div>
    <div :class="selectClass">
      <label :for="id" class="pl-form-label" :class="labelClass">
        <span v-html="label"></span>
        <span v-if="required">&nbsp;*</span>
      </label>
      <app-select
        :name="id"
        :id="id"
        :required="true"
        :disabled="disabled"
        :options="options"
        :elClass="[{'alert-border': isShown}]"
        @change="onChange($event)"
        @focus="onFocus"
      ></app-select>
    </div>
    <div  style="min-height: 18px">
      <div class="pl-form-validation" style="height: auto; min-height: 0">
        <span v-if="isShown">This is a required field</span>
      </div>
      <div class="pl-form-additional-info" v-if="formInfo">
        <template v-if="!isShown">
          <span v-html="formInfo"></span>
        </template>
      </div>
      <div class="pl-form-additional-info" v-if="fieldInfo">
          <span v-html="fieldInfo"></span>
      </div>
    </div>
  </div>
</template>
<script>
import AppSelect from "./AppSelect";
export default {
  name: "select-group",
  props: {
    id: String,
    label: String,
    title: String,
    required: Boolean,
    disabled: Boolean,
    selectClass: String,
    labelClass: String,
    titleClass: String,
    groupClass: String,
    formInfo: String,
    fieldInfo: String,
    value: String,
    options: Array,
    validator: Boolean
  },
  data() {
    return {
      isShown: false
    };
  },
  watch: {
    validator: function() {
      this.isShown = this.validator;
    }
  },
  methods: {
    onChange(event) {
      let emitValue = {};
      emitValue.name = event.target.id;
      emitValue.value = event.target.value;
      if (event.target.score) {
        emitValue.score = event.target.score;
      }
      this.$emit("change", emitValue);
    },
    onFocus() {
      this.$emit("focus", this.id);
    }
  },
  components: {
    AppSelect
  }
};
</script>